module.exports = __webpack_public_path__ + "img/073422.128adcb9.png";